import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'
import store from './store'

import Vuex from 'vuex'
import Vue from "vue";
import * as echarts from "echarts";

/**
 * 导出数据为excel
 * @param date '2022-05-21'
 * @param briefing 表名 'div拖动'
 */
createApp(App).use(router).use(store).use(ElementPlus).directive('drag', (obj, binding) =>{
  
    obj.onmousedown = function(el){
      var left = obj.offsetLeft;
      var top = obj.offsetTop;
      var width = obj.offsetWidth;
      var height = obj.offsetHeight;
  
      //计算出鼠标的位置与元素位置的差值。
      var cleft = el.clientX - left;
      var ctop = el.clientY - top;
  
      document.onmousemove = function (doc) {
        //计算出移动后的坐标。
        var moveLeft = doc.clientX - cleft;
        var moveTop = doc.clientY - ctop;
  
        //设置成绝对定位，让元素可以移动。
        obj.style.position = "absolute";
  
        //当移动位置在范围内时，元素跟随鼠标移动。
        obj.style.left = moveLeft<0?'0':moveLeft + "px";
        obj.style.top = moveTop<0?'0':moveTop + "px";
      }
  
      document.onmouseup = function () {
        document.onmousemove = function () { }
      };
    }
  })
  .mount('#app');
  // VueAMap.initAMapApiLoader({
  //   // 高德的key
  //   key: '538ae29946173b310783d428d8cd6dd5',
  //   // 插件集合
  //   plugin: ['AMap.Autocomplete', 'AMap.GeoJSON', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  //   // 高德 sdk 版本，默认为 1.4.4
  //   v: '1.4.4'
  // });